import React, { useCallback } from 'react'
import styled from 'styled-components'
import Icon from 'components/Icon'
import { useDispatch } from 'react-redux'
import { useDeleteItem } from '../hooks'
import { _ } from '../utils'
import { addModal } from '../features/modals/modalSlice'
import TagModal from './TagModal'

const S = {
    Wrapper: styled.div`
        display: grid;
        width: 100%;
        height: 40px;
        grid-template-columns: 1fr 1fr;
        margin-bottom: 3px;
        &:hover > .actions > * {
            opacity: 1;
        };
    `,
    Actions: styled.div`
        display: flex;
        align-items: center;
        justify-content: flex-end;
         & > * {
            opacity: 0;
        }
    `,
    TagColor: styled.span<{ color: string }>`
        content: "";
        border-radius: 50%
        width: 10px;
        height: 10px;
        position: relative;
        padding-left: 21px;
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        ::after {
            content: "";
            position: absolute;
            top: 2px;
            left: 3px;
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background: ${({ color }) => color};
    }
    `,
    Tag: styled.div`
        display: flex;
        align-items: center;
    `
}

export interface Tag {
    id: number,
    color: string,
    text: string,
    order: number,
    categoryId?: number,
}

interface Props{
    tag: Tag,
    fetchData: () => Promise<void>,
    deleteRow: (id) => Promise<void>,
    updateTag:({ text, color, categoryId }, id) => Promise<void>
}

const TagRow = ({
    tag, fetchData, deleteRow, updateTag
} : Props) => {
    const dispatch = useDispatch()
    const { showDeleteConfirmModal } = useDeleteItem(
        deleteRow, fetchData, {
            title: _('show.program_tag.delete_tag_title'),
            description: _('show.program_tag.delete_tag_description')
        }
    )
    const onDeleteTag = useCallback(() => {
        showDeleteConfirmModal(tag.id)
    }, [tag, showDeleteConfirmModal])
    const showTagModal = useCallback(() => {
        dispatch(addModal({
            Component: ({ close }: { close: () => void }) => (
                <TagModal
                    close={close}
                    onSubmitted={fetchData}
                    tag={tag}
                    updateTag={updateTag}
                />
            ),
            size: 'xl',
            shouldNotWrap: true
        }))
    }, [dispatch, fetchData, tag, updateTag])
    return (
        <S.Wrapper>
            <S.Tag>
                <S.TagColor color={tag.color} />
                <span>{tag.text}</span>
            </S.Tag>
            <S.Actions className="actions">
                <Icon onClick={showTagModal} icon="edit" size={18} style={{ marginRight: 12 }} />
                <Icon
                    icon="trash"
                    size={18}
                    onClick={onDeleteTag}
                    style={{ marginRight: 12 }}
                />
            </S.Actions>
        </S.Wrapper>
    )
}

export default TagRow
